export default __webpack_public_path__ + "static/media/logo_Qibo-io.029c8426.svg";